module.exports = __webpack_public_path__ + "img/2.fde38ad2.png";